export enum TicketStatus {
  Approved = 'approved',
  Archived = 'archived',
  New = 'new',
  Waiting = 'waiting',
  Resolved = 'resolved',
  Canceled = 'canceled',
  Deleted = 'deleted'
}
